import { ICard } from "@/store/apis/deckAPI"
import { IMongoDocument, IPaginationReq } from "@/types"
import { CARD_SKIN_TYPES } from "../cardBacksAPI"

export enum STORE_ITEM_TYPES {
  CARD_BACK = "CardBack",
  CARD = "Card"
}

export interface IStoreDto extends IPaginationReq {
  type?: STORE_ITEM_TYPES
  populate?: boolean
}

export interface IStoreItemSkin extends IMongoDocument {
  backImgSrc: string
  colorBg: string
  colorBgShadow: string
  colorDescription: string
  colorTitle: string
  exampleImgSrc: string
  frontImgSrc: string
  type: CARD_SKIN_TYPES
}

export interface IStoreItemSkinGoldCard extends ICard {
  coolDownMovements: number
  maxUsesPerGame: number
}

export type IStoreDataMap = {
  [STORE_ITEM_TYPES.CARD_BACK]: IStoreItemSkin
  [STORE_ITEM_TYPES.CARD]: IStoreItemSkinGoldCard
}

export type IStoreAnyItem = {
  [K in STORE_ITEM_TYPES]: IStoreItem<K>
}[STORE_ITEM_TYPES]

export interface IStoreItem<
  T extends STORE_ITEM_TYPES = STORE_ITEM_TYPES.CARD_BACK
> extends IMongoDocument {
  type: T
  dataId: string
  data?: IStoreDataMap[T]
  pricing: {
    ton: number
    stars: number
    goldenDust: number
    isTonEnabled: boolean
    isStarsEnabled: boolean
    isGoldenDustEnabled: boolean
  }
}
